import { render } from "./TheLoginForm.vue?vue&type=template&id=6b4bff57&scoped=true&ts=true"
import script from "./TheLoginForm.vue?vue&type=script&lang=ts"
export * from "./TheLoginForm.vue?vue&type=script&lang=ts"

import "./TheLoginForm.vue?vue&type=style&index=0&id=6b4bff57&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4bff57"]])

export default __exports__